export const interviewDocument = {
    addTitleForm: "Een pdf-interviewrapport toevoegen",
    updateTitleForm: "Een pdf-interviewrapport vervangen",
    uploadNewDoc: "Uploaden",
    modifyDoc: "Vervangen",
    upload_title: "{{abbreviation}} {{location}} op {{audit_date}}",
}